export class VisitePortale {
    portale: string;
    dateIncontri: Date[];
    dateIncontriString: string[];
    partite: string[];
    visiteTotali: number[];
    ipUnivoci: number[];

    constructor(){
        this.dateIncontri = new Array<Date>();
        this.dateIncontriString = new Array<string>();
        this.partite = new Array<string>();
        this.visiteTotali = new Array<number>();
        this.ipUnivoci = new Array<number>();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/visite-portale.ts